<template>
  <section class="flex flex-col w-full">
    <h2 class="text-lg font-bold mb-3">
      - めざせ！<ruby
        ><rb>記録更新</rb><rp>（</rp><rt>きろくこうしん</rt><rp>）</rp></ruby
      >
      -
    </h2>
    <m-learning-summary-card
      title="これまでの学習日数（がくしゅうにっすう）"
      :values="point"
      class="mb-4"
    />
    <div class="mb-4 flex">
      <m-learning-summary-card
        title="いまのれんぞく日数（にっすう）"
        :values="currentRunningDayCount"
        class="mr-2 flex-1"
      />
      <m-learning-summary-card
        title="いちばん長（なが）くつづいた日数（にっすう）"
        :values="maxRunningDayCount"
        class="ml-2 flex-1"
      />
    </div>
  </section>
</template>

<script lang="ts">
import MAHistoryPanel from "@/components/analyze/MAHistoryPanel.vue";
import MLearningSummaryCard from "@/components/MLearningSummaryCard.vue";
import { LearningSummaryData } from "@/components/MLearningSummaryCard.vue";
import store from "@/store";
import { Options, Vue } from "vue-class-component";
import { Student } from "@/entities/student";
import dayjs from "dayjs";

@Options({
  components: {
    MAHistoryPanel,
    MLearningSummaryCard
  },
  props: {
    student: Object
  }
})
export default class Home extends Vue {
  student!: Student;

  get point(): LearningSummaryData[] {
    return [
      {
        num: store.getters.totalLearningDayCount,
        label: "日"
      }
    ];
  }

  get currentRunningDayCount(): LearningSummaryData[] {
    return [
      {
        num: store.getters.consecutiveLearningDayCount,
        label: "日"
      }
    ];
  }

  get maxRunningDayCount(): LearningSummaryData[] {
    return [
      {
        num: store.getters.maxConsecutiveLearningDayCount,
        label: "日"
      }
    ];
  }

  get lastWeekStartTime() {
    const start = dayjs()
      .locale("ja")
      .add(-6, "day")
      .startOf("day");
    return start.unix();
  }
  get lastWeekEndTime() {
    const end = dayjs()
      .locale("ja")
      .endOf("day");
    return end.unix();
  }
}
</script>
